<template>
  <div>
    <div class="row">
      <div class="col">
        <ValidationProvider rules="required" v-slot="{ errors }">
          <v-text-field
            outlined
            hide-details
            label="Код набора"
            :error-messages="errors"
            v-model="set.code"
            clearable
          ></v-text-field>
        </ValidationProvider>
      </div>
      <div class="col">
        <ValidationProvider rules="required" v-slot="{ errors }">
          <v-text-field
            outlined
            hide-details
            label="Название набора"
            :error-messages="errors"
            v-model="set.name"
            clearable
          ></v-text-field>
        </ValidationProvider>
      </div>
    </div>
    <div class="row">
      <template v-for="(field,i) in set.fields">
        <div class="col-3" :key="i">
          <Field :field="field" :set="set" :template="getFieldTemplateByCode(field.field)"></Field>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Field from './Field.vue';

export default {
  props: ['set', 'template'],
  components: { Field },
  name: 'Set',
  methods: {
    getFieldTemplateByCode(code) {
      return this.template.fields.find((field) => field.code === code);
    },
  },
};
</script>
